import api from './api';

const moderationConfigService = {
  // Get moderation configuration
  getConfig: async () => {
    const response = await api.get('/admin/moderation-config/');
    return response.data;
  },

  // Update moderation configuration
  updateConfig: async (configData) => {
    const response = await api.put('/admin/moderation-config/1/', configData);
    return response.data;
  },
};

export default moderationConfigService;











